<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="600px"
  >
    <v-card>
      <v-card-text>
        <v-container>
          <v-form
            ref="formNewCliente"
            lazy-validation
            @submit.prevent="save()"
          >
            <v-card-title class="pa-2">
              {{ isEdit ? 'Modificar cliente' : 'Registrar cliente' }}
              <v-spacer />
            </v-card-title>

              <v-text-field
                v-model="nombre_comercial"
                class="px-2 py-1"
                flat
                label="Nombre comercial"
                outlined
                :rules="[v => !!v || 'Nombre comercial es obligatorio']"
                required
              />

              <v-text-field
                v-model="razon_social"
                label="Razon Social (opcional)"
                class="px-2 py-1"
                flat
                required
                outlined
              />
                <!-- :rules="[v => !!v || 'La razon social es obligatorio']" -->

            <v-row no-gutters>
              <v-col cols="6">
                <v-text-field
                  v-model="ruc"
                  class="px-2 py-1"
                  flat
                  label="RUC (opcional)"
                  required
                  outlined
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="direccion"
                  class="px-2 py-1"
                  flat
                  label="Direccion"
                  :rules="[v => !!v || 'Direccion es obligatorio']"
                  required
                  outlined
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="tipo_de_cliente"
                  class="px-2 py-1"
                  flat
                  label="Seleccione tipo de cliente"
                  :items="tipos_de_clientes"
                  required
                  :rules="[v => !!v || 'El tipo de cliente es obligatorio']"
                  outlined
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="estado_de_negociacion"
                  class="px-2 py-1"
                  outlined  
                  flat
                  :items="estados_de_negociacion"
                  label="Seleccione estado de negociacion"
                  :rules="[v => !!v || 'Seleccionar estado de negociacion es obligatorio']"
                  required
                />
              </v-col>

              <v-col cols="6">
                <v-select
                  v-model="canal_de_venta"
                  class="px-2 py-1"
                  outlined  
                  flat
                  :items="canales_de_ventas"
                  label="Seleccione canal de venta"
                  :rules="[v => !!v || 'Seleccionar canal de venta es obligatorio']"
                  required
                />
              </v-col>

              <v-col cols="6">
                <v-select
                  v-model="departamento"
                  class="px-2 py-1"
                  outlined
                  flat
                  :items="departamentos"
                  label="Seleccione departamento"
                  :rules="[v => !!v || 'Seleccionar departamento es obligatorio']"
                  @change="onChangeRegion"
                />
              </v-col>
              <v-col cols="6">
              <v-select
                v-model="provincia"
                class="px-2 py-1"
                outlined
                flat
                :items="provincias"
                label="Seleccione la provincia (Excepto region Lima, Seleccione distrito)"
                :rules="[v => !!v || 'Seleccionar la provincia es obligatorio']"
              />
              </v-col>

              <!-- //vendedor  -->
              <v-col cols="6">
                <v-select
                  v-model="email" 
                  class="px-2 py-1"
                  outlined
                  flat
                  :items="email_users"
                  label="Seleccione vendedor"
                  :rules="[v => !!v || 'Seleccionar correo del vendedor']"
                />
              </v-col>

                  <!-- aria-autocomplete="off" -->
              <v-col cols="6">
                <v-text-field
                  autocomplete="false"
                  class="px-2 py-1"
                  flat
                  label="Numero de tiendas"
                  :rules="[
                    v => !!v || 'El numero de tiendas es obligatorio',
                    v => v > 0 || 'El numero de tiendas no es valido'
                  ]"
                  required
                  outlined
                />
              </v-col>

              <v-col cols="6">
                
                <v-combobox
                  v-model="model"
                  :hide-no-data="!search"
                  :search-input.sync="search"
                  :filter="filter"
                  :items="perfil_de_clientes"
                  label="Seleccione perfil de cliente"
                  :rules="[v => !!v || 'El perfil del cliente es obligatorio']"
                  outlined
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <span class="subheading">Crear perfil: </span>
                      <v-chip
                        class="mx-1"
                        :color="`${colors[nonce - 1]} lighten-3`"
                        label
                        small
                        @click="createPerfilCliente"
                      >
                        {{ search }}
                      </v-chip>
                    </v-list-item>
                  </template>
                  <template v-slot:selection="{ item }">
                    <!-- <v-chip
                      v-if="item === Object(item)"
                      v-bind="attrs"
                      :color="`${item.color} lighten-3`"
                      :input-value="selected"
                      label
                      small
                    > -->
                      <span class="pr-2">
                        {{ item.text }}
                      </span>
                      <!-- <v-icon
                        small
                        @click="parent.selectItem(item)"
                      >
                        $delete
                      </v-icon> -->
                    <!-- </v-chip> -->
                  </template>
                  <template v-slot:item="{ index, item }">
                    <v-text-field
                      v-if="editing === item"
                      v-model="editing.text"
                      autofocus
                      flat
                      background-color="transparent"
                      hide-details
                      solo
                      @keyup.enter="edit(index, item)"
                    ></v-text-field>
                    <span
                      v-else
                    >
                      {{ item.text }}
                    </span>
                    <v-spacer></v-spacer>
                    <v-list-item-action @click.stop>
                      <v-btn
                        small 
                        icon
                        @click.stop.prevent="edit(index, item)"
                      >
                        <v-icon size="14">{{ editing !== item ? 'mdi-pencil' : 'mdi-check' }}</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </template>
                </v-combobox>
              </v-col>
              
            <v-menu
              ref="menuFechaUltimaVisita"
              v-model="menu_fecha_ultima_visita"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
              >
              <template v-slot:activator="{ on, attrs }">
                  <!-- v-model="computedDateFormattedMomentjs" -->
                  <!-- :value="computedDateFormattedMomentjs" -->
                  <v-text-field
                  v-model="fecha_ultima_visita"
                  label="Fecha de ultima visita"
                  prepend-icon="mdi-calendar"
                  readonly
                  outlined
                  :rules="[v => !!v || 'Fecha de ultima visita es obligatorio']"
                  v-bind="attrs"
                  v-on="on"
                  >
                  </v-text-field>
              </template>
              <v-date-picker
                  v-model="fecha_ultima_visita"
                  locale="es"
                  @change="menu_fecha_ultima_visita = false"
              >
                  <!-- <v-spacer />
                  <v-btn
                  text
                  color="primary"
                  @click="menu_fecha_ultima_visita = false"
                  >
                  Cancel
                  </v-btn>
                  <v-btn
                  text
                  color="primary"
                  @click="$refs.menuFechaUltimaVisita.save(fecha_ultima_visita)"
                  >
                  OK
                  </v-btn> -->
              </v-date-picker>
            </v-menu>

              <!-- <v-col cols="6">
              <v-select
                v-if="isAdmin && isEdit"
                v-model="email"
                class="px-2 py-1"
                outlined
                flat
                :items="users"
                label="Usuario a cargo"
              />
                @change="getUserByEmail"
              </v-col> -->

            </v-row>

            <v-card-actions class="pa-2">
              <v-btn
                outlined
                @click="close"
              >
                Cancelar
              </v-btn>
              <v-spacer />
              <v-btn
                color="primary"
                type="submit"
                :loading="loading"
              >
                Guardar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>

    <v-snackbar
      v-model="snackbar"
    >
    {{ snackbarTxt }}
  </v-snackbar>

  </v-dialog>
            <!-- </v-card-text> -->
</template>

<script>

  import firebase from 'firebase'
  import moment from 'moment'

  const db = firebase.firestore()

  export default {
    data () {
      return {
        // combobox
          activator: null,
          attach: null,
          colors: ['red', 'blue', 'green', 'purple', 'indigo', 'cyan', 'teal', 'orange'],
          editing: null,
          editingIndex: -1,
          perfil_de_clientes: [
            { header: 'Seleccione o cree un perfil' }
          ],
          nonce: 1,
          menu: false,
          model: null,
          x: 0,
          search: null,
          y: 0,
        ///  module
        cliente: undefined,
        departamentos: [],
        provincias: [],
        ruc: '',
        direccion: '',
        estado_de_negociacion: '',
        estados_de_negociacion: '',
        tipos_de_clientes: [],
        canales_de_ventas: [],
        loading: false,
        nombre_comercial: '',
        tipo_de_cliente: '',
        razon_social: '',
        canal_de_venta: '',
        dialog: false,
        departamento: '',
        provincia: '',
        snackbar: false,
        snackbarTxt: '',
        email: '',
        email_users: [],
        n_tienda: null,
        perfil_de_cliente_selected: null,
        // perfil_de_clientes: ['FERRETERÍA', 'DRYWALL', 'MELAMINERO', 'MADERERO'],
        menu_fecha_ultima_visita: false,
        fecha_ultima_visita: null,
      }
    },
    computed: {
      isEdit () {
        return this.cliente === undefined ? false : 'qw'
      },
      isAdmin () {
        return JSON.parse(localStorage.userAuth).perfil !== 'Administrador' ? false : 'a'
      },
      computedDateFormattedMomentjs () {
        return this.fecha_ultima_visita ? moment(this.fecha_ultima_visita).format('L') : ''
      },
    },
    watch: {
    model (val, prev) {
      if (val === prev) return

      this.model = val
    }
  },
    mounted () {
      this.tipos_de_clientes = this.$store.state.tipo_de_cliente_distribuidores
      this.canales_de_ventas = this.$store.state.canales_de_venta_distribuidores
      this.estados_de_negociacion = this.$store.state.estados_de_negociacion
      this.getDepartamentos()
      this.getUsers()
      this.getPerfil()
    },
    methods: {
      // metodos de combox
      edit (index, item) {
      if (!this.editing) {
        this.editing = item
        this.editingIndex = index
      } else {
        this.editing = null
        this.editingIndex = -1
        this.updatePerfil(item)
      }
    },
    filter (item, queryText, itemText) {
      if (item.header) return false

      const hasValue = (val) => val !== null ? val : ''

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString()
        .toLowerCase()
        .indexOf(query.toString().toLowerCase()) > -1
    },
    async createPerfilCliente () {
        const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/cliente/perfilCliente', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              perfil_de_cliente: this.search || '',
            })
          })
          const data = await response.json()
          if (data.success) {
            this.getPerfil()
            // this.search = null
          }
    },
    async updatePerfil (perfil) {
        const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/cliente/perfilCliente/' + perfil.id, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              perfil_de_cliente: perfil.text || '',
            })
          })
          const data = await response.json()
          if (data.success) {
            this.getPerfil()
            // this.search = null
          }
    },
    async open (cliente) {
        this.dialog = true
        this.cliente = cliente
        if (this.isEdit) {
            this.nombre_comercial = cliente.nombre_comercial
            this.razon_social = cliente.razon_social
            this.ruc = cliente.ruc
            this.estado_de_negociacion = cliente.estado_de_negociacion
            this.direccion = cliente.direccion_cliente
            this.email = cliente.email_user
            this.razon_social = cliente.razon_social
            this.razon_social = cliente.razon_social
            this.canal_de_venta = cliente.canal_de_venta
            this.tipo_de_cliente = cliente.tipo_de_cliente
            this.departamento = this.cliente.departamento
            this.n_tienda = cliente.n_tienda
            this.perfil_de_cliente_selected = cliente.perfil_de_cliente
            this.perfil_de_clientes.forEach(perfil => {
              if (perfil.text === cliente.perfil_de_cliente) {
                this.model = perfil
              }
            })
            this.fecha_ultima_visita = cliente.fecha_ultima_visita
            // this.provincia = this.cliente.provincia
          if (cliente?.departamento) {
            this.departamento = cliente?.departamento
          }
          if (cliente?.provincia) {
            this.provincia = cliente?.provincia.trim()
            var privinciaSeleccionadaByFiltro = await this.$store.state.regiones.filter(region => region.NOMBRE === cliente?.departamento)
            this.provincias = privinciaSeleccionadaByFiltro[0]?.PROVINCIAS
          }
        }
      },
      close () {
        this.$refs.formNewCliente.reset()
        this.dialog = false
        this.loading = false
      },
      getDepartamentos () {
        this.departamentos = []
        this.$store.state.regiones.forEach(region => {
          this.departamentos.push(region.NOMBRE)
        })
      },
      getUsers () {
        db.collection('users').get().then(users => {
          users.forEach(user => {
            this.email_users.push(user.data().email)
          })
        })
      },
      onChangeRegion () {
        var privinciaSeleccionadaByFiltro = this.$store.state.regiones.filter(region => region.NOMBRE === this.departamento)
        this.provincias = privinciaSeleccionadaByFiltro[0].PROVINCIAS
      },
      async save () {
        if (this.$refs.formNewCliente.validate() && this.isEdit === false) {
          this.loading = true
          const payload = {
              nombre_comercial: this.nombre_comercial,
              tipo_de_cliente: this.tipo_de_cliente,
              razon_social: this.razon_social,
              canal_de_venta: this.canal_de_venta,
              departamento: this.departamento,
              provincia: this.provincia,
              ruc: this.ruc,
              direccion_cliente: this.direccion,
              estado_de_negociacion: this.estado_de_negociacion,
              email_user: this.email,
              n_tienda: parseInt(this.n_tienda),
              perfil_de_cliente: this.model.text,
              fecha_ultima_visita: this.fecha_ultima_visita.replace('/', '-')
          }

          const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/distribuidores/prospectar',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(payload)
            })

          const data = await response.json()
          if (data.success) {
              this.loading = false
              this.close()
              this.$emit('onCreateCliente')
            } else {
              this.snackbar = true
              this.snackbarTxt = 'No se pudo crear cliente'
              this.loading = false
            }
        } else {
          if (this.$refs.formNewCliente.validate() && this.isEdit) {
            this.loading = true
            const payload = {
              nombre_comercial: this.nombre_comercial,
              tipo_de_cliente: this.tipo_de_cliente,
              razon_social: this.razon_social,
              canal_de_venta: this.canal_de_venta,
              departamento: this.departamento,
              provincia: this.provincia,
              ruc: this.ruc,
              direccion_cliente: this.direccion,
              estado_de_negociacion: this.estado_de_negociacion,
              email_user: this.email,
              n_tienda: parseInt(this.n_tienda),
              perfil_de_cliente: this.model.text,
              fecha_ultima_visita: this.fecha_ultima_visita.replace('/', '-')

            }

            const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/distribuidores/prospectar/' + this.cliente.id,
              {
                method: 'PUT',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
              })
            const data = await response.json()
            if (data.success) {
              this.loading = false
              this.close()
              this.$emit('onCreateCliente')
            } else {
              this.snackbar = true
              this.snackbarTxt = 'La no se pudo modificar los datos del cliente'
              this.loading = false
            }
          }
        }
      },
      async getPerfil () {
        const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/cliente/perfilClientes')
          const data = await response.json()
        if (data.success) {
          data.data.forEach(perfil => {
            const payload = {
                id: perfil.id,
                text: perfil.perfil_de_cliente,
              }
              this.perfil_de_clientes.push(payload)
          })
        }
      }
    },

  }
</script>

<style>
</style>
